export { default } from "./welcomeDobScreen";
